module.exports = __webpack_public_path__ + "BlueStrategy.0bc5e63.png";